import React from 'react'
import styles from './TripLaps.scss'
import {FullBleedList} from 'features/routes/RouteShowPage/SidePanel/FullBleedList'
import {Distance, Elevation, Duration} from 'common/units'

class TripLap extends React.PureComponent {
  render () {
    const {lap, i} = this.props
    return (
      <li className={styles.TripLap}>
        {/* we probably need to go back to 00:00:00 styled durations everywhere. */}
        <div>#{i + 1} – <Duration bigUnits valueOnly value={lap.moving_time} /></div>
        <div style={{flex: '0 0 auto'}}>
          <span className={styles.eleGain}>+<Elevation short value={lap.elevation_gain} /></span>
          <span className={styles.distance}><Distance short value={lap.distance} bigUnits /></span>
        </div>
      </li>
    )
  }
}

export class TripLaps extends React.PureComponent {
  render () {
    const {trip} = this.props
    if (!trip.lapSummaries || trip.lapSummaries.length === 0) {
      return null
    }
    return (
      <div className={styles.TripLaps}>
        <h2>Laps</h2>
        <FullBleedList>
          {trip.lapSummaries.map((lap, i) => (
            <TripLap lap={lap} i={i} />
          ))}
        </FullBleedList>
      </div>
    )
  }
}
